// extracted by mini-css-extract-plugin
export default {"spinner":"spinner---YDQMU","sk-bouncedelay":"sk-bouncedelay---mf97_","bounce1":"bounce1---ZnlQ3","bounce2":"bounce2---Z3xEg"};